    export const UNITTYPE_EVENT_CREATE_EDIT_OPEN_MODAL = "UNITTYPE_EVENT_CREATE_EDIT_OPEN_MODAL";
    export const UNITTYPE_EVENT_CREATE_REQUEST = "UNITTYPE_EVENT_CREATE_REQUEST";
    export const UNITTYPE_EVENT_CREATE_RESULT = "UNITTYPE_EVENT_CREATE_RESULT";
    export const UNITTYPE_EVENT_EDIT_REQUEST = "UNITTYPE_EVENT_EDIT_REQUEST";
    export const UNITTYPE_EVENT_EDIT_RESULT = "UNITTYPE_EVENT_EDIT_RESULT";
    export const UNITTYPE_EVENT_GET_REQUEST = "UNITTYPE_EVENT_GET_REQUEST";
    export const UNITTYPE_EVENT_GET_RESULT = "UNITTYPE_EVENT_GET_RESULT";
    export const UNITTYPE_EVENT_GET_UNIT_TYPES_REQUEST = "UNITTYPE_EVENT_GET_UNIT_TYPES_REQUEST";
    export const UNITTYPE_EVENT_GET_UNIT_TYPES_RESULT = "UNITTYPE_EVENT_GET_UNIT_TYPES_RESULT";